import React, { useContext, useEffect, useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
    Textarea,
    Input,
    useToast,
    Spinner,
  } from '@chakra-ui/react';
  import { CiDeliveryTruck } from "react-icons/ci";
import axios from 'axios';
import { orders_uri, users_uri } from '../../../uri';
import { AuthContext } from '../../../context/auth';

const DeliveryModal = ({data, callback}) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isOpen1, onOpen: onOpen1, onClose: onClose1 } = useDisclosure();
    const {currentUser} = useContext(AuthContext);
    const [datas, setDatas] = useState({phone:"", address:"", explanation:"", token: currentUser, address_id:1});
    const [deliv, setDeliv] = useState(false);
    const [load, setLoad] = useState(false);
    const [address, setAddress] = useState([]);
    const toast = useToast();

    const handlecall = () => {
      callback();
    }

    const Sub = async () => {
      if(datas.phone === "")
        return toast({title: 'Мэдээлэл дутуу байна ',status: 'warning',duration: 5000,isClosable: true,});

      if(datas.address_id === 1)
        return toast({title: 'Гэрийн хаяг сонгоогүй байна',status: 'warning',duration: 5000,isClosable: true,});

      setLoad(true);
      try{
        const res = await axios.post(orders_uri+"/delivery/web", datas);
        if(res.status === 200){
          onClose();
          handlecall();
          toast({title: 'Амжилттай бүртгүүллээ',status: 'success',duration: 5000,isClosable: true,});
          setDatas({...datas, phone:"", address:"", address_id: 1});
          // onOpen1();
        }

        setLoad(false);
      }catch(err){
        setLoad(false);
        console.log(err);
      }
    }

    useEffect(() => {
      Gets();
    }, []);
  
    const Gets = async () => {
      try{
        const res = await axios.get(users_uri+`/address/get?token=${currentUser}`);
        setAddress(res.data);
        // setLoad(false);
      }catch(err){
        console.log(err);
        // setLoad(false);
      }
    }

    const Get = async () => {
      setLoad(true);
      try{
        const res = await axios.get(orders_uri+"/delivery-check" + `?token=${currentUser}` );
        if(res.status === 208){
          setDeliv(true);
        }
        setLoad(false);
      }catch(err){
        console.log(err);
        setLoad(false);
      }
    }

    const callFunc = () => {
      onOpen();
      Get();
    }
    
  return (
    <>
      <div onClick={callFunc} className='p-2 rounded-xl cursor-pointer hover:bg-green-600 bg-green-500 w-60 text-white text-center'>
        Хүргэлтэнд бүртгүүлэх
      </div>

      <Modal size="4xl" isOpen={isOpen} onClose={onClose} className="font-Roboto">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Хүргэлтэнд бүртгүүлэх</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {
              deliv ?
              <div>
                <h1>Та хүргэлтэнд бүртгүүлэсэн байна.</h1>
              </div>
              :
              <div>
                <h1 className='font-bold mb-4'>Таньд {data} бараа ирсэн байна.</h1>

                <h1 className='text-sm mb-2'>Нэмэлт утасны дугаар</h1>
                <Input onChange={(e) => setDatas({...datas, phone:e.target.value})} className="" placeholder='99119911'/>

                <h1 className='text-sm mb-2 mt-4'>Тэмдэглэл </h1>
                <Textarea onChange={(e) => setDatas({...datas, explanation:e.target.value})} className="" placeholder='Тэмдэглэл бичих'/>
                <div className='mt-4 mb-2'>
                  <h1>Хаяг сонгох</h1>
                </div>

                {
                    address.length === 0 &&
                    <div className=' flex items-center justify-center flex-col mt-6'>
                        <img className='h-24' src='../../icons/empty-box.png'/>
                        <h1 className='mt-2 text-center'>Хаягийн мэдээлэл цэсрүү орж хаягаа нэмээрэй</h1>
                    </div>
                }

                {
                    address.map((it, index) => {
                        return(
                            <div key={index} className=' mt-1 flex items-center gap-2 cursor-pointer' onClick={(e) => setDatas({...datas, address_id:it.id})}>
                                {
                                  datas.address_id === it.id ?
                                  <div className='border rounded-full bg-green-500 p-2'> </div>
                                    :
                                  <div className='border rounded-full p-2'> </div>
                                }
                               
                                <div className='flex gap-6 border rounded-xl p-2 w-full'>
                                    <div>
                                        <h1 className='text-gray-500 text-sm'>Аймаг / Хот</h1>
                                        <p className='uppercase text-sm font-bold'>{it.city}</p>
                                    </div>
                                    <div>
                                        <h1 className='text-gray-500 text-sm'>Сум / Дүүрэг</h1>
                                        <p className='uppercase text-sm font-bold'>{it.district}</p>
                                    </div>
                                    <div className=''>
                                      <h1 className='text-gray-500 text-sm'>Баг / Хороо</h1>
                                      <p className='uppercase text-sm font-bold'>{it.khoroo}</p>
                                    </div>
                                    <div className=''>
                                        <h1 className='text-gray-500 text-sm'>Хаяг</h1>
                                        <p className='uppercase text-sm font-bold'>{it.address}</p>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
                
              </div>
            }
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose}>
              Болих
            </Button>
            {
              load ?
              <Button variant='ghost'><Spinner/></Button>
              :
              <Button variant='ghost' onClick={Sub}>Бүртгүүлэх</Button>
            }
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpen1} onClose={onClose1} className="font-Roboto">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <img src='../../images/sanamj.jpg'/>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='blue' mr={3} onClick={onClose1}>
              Ok
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

    </>
  )
}

export default DeliveryModal
